import { delay } from 'redux-saga'
import { call, put, takeLatest } from 'redux-saga/effects'
import * as lastViewedCandidateModule from '@/CandidateListES/redux/modules/lastViewedCandidate'
import { errorHandler } from '@/core/helpers/errorHelpers'

function* lastViewedCandidateSaga() {
  try {
    // wait 2 secs before removing candidate slug
    yield call(delay, 2000)
    yield put(lastViewedCandidateModule.resetCandidateSlug())
  } catch (err) {
    yield call(errorHandler, err)
  }
}

export default function* watchLastViewedCandidateSaga() {
  yield takeLatest(lastViewedCandidateModule.SAVE_CANDIDATE_SLUG, lastViewedCandidateSaga)
}
